export default __webpack_public_path__ + "static/techguru-example11-7808c02d240b09f5a0dafc093a91f567.png";